module.exports = __webpack_public_path__ + "img/laplata.ddb27557.jpg";